(function () {
    'use strict';
    app.service('userManagementService', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deferred;

        this.getData = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getUserManagementData", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getDataReport = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getUserManagementDataReport", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getFullDataReport = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getUserManagementFullDataReport", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.resetPassword = function (resetPasswordInfo) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/Account/changePassword_superadmin", resetPasswordInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.notificationSuperadminChangePassword = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/notificationSuperadminChangePassword", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            //.catch(function (err) {
            //    deferred.resolve(err);
            //});

            return deferred.promise;
        }

        this.getStatusData = function () {
            deferred = $q.defer();

            $http.get(serviceBase + "status")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.updateStatus = function (data) {
            deferred = $q.defer();

            $http.get(serviceBase + "api/super/updateStatus?emailID=" + data.emailID + "&userID=" + data.userID + "&userStatusID=" + data.statusId + "&statusValue=" + data.statusValue + "&username=" + data.username + "&eSpectraAdminNote=" + data.eSpectraAdminNote + "&eSpectraAdminNoteID=" + data.eSpectraAdminNoteID + "&statusDate=" + data.statusDate)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.sendSuspendedUserAccountMailtoUser = function (emailID, userFirstName) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/sendSuspendedUserAccountMailtoUser?emailID=" + emailID + "&userFirstName=" + userFirstName)
               .then(function (response) {
                   deferred.resolve(response);
               })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.sendDeletedUserAccountMailtoUser = function (emailID, userFirstName) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/sendDeletedUserAccountMailtoUser?emailID=" + emailID + "&userFirstName=" + userFirstName)
               .then(function (response) {
                   deferred.resolve(response);
               })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.saveAdminUpdatedUserProfile = function (userData) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/saveAdminUpdatedUserProfile/", userData)
               .then(function (response) {
                   deferred.resolve(response);
               })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.getUserSubPackPurchaseDetails = function (userId) {
            deferred = $q.defer();

            $http.get(serviceBase + "api/super/userSubPackPurchaseDetails?userID="+ userId)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getUserStatusHistory = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getUserStatusHistory", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

    }
    ]);
})();